import React, { Component } from 'react'
import css from './style.css'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import Menu from '../menu'
import CurrencyMenu from '../currency-menu'
import * as actions from '../../actions/settings'

const mapStateToProps = (state, ownProps) => {
  return {
    ...state.settings,
    cartVisible: state.settings.cartVisible
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    toggleDisplayCart: (e) => {
      if (e) e.preventDefault()
      dispatch(actions.toggleDisplayCart())
    }
  }
}

class Navigation extends Component {
  render () {
    return (
      <div className={css.navContainer}>
        <nav className={css.navigation}>
          <div className={css.logo}>
            <Link to='/'>
              <img
                src={require('./logo.png')}
                srcSet={[
                  require('./logo.png') + ' 1x',
                  require('./logo@2x.png') + ' 2x'
                ]}
              />
            </Link>
          </div>
          <div className={css.links}>
            <Link to='/welcome' activeClassName={css.active}>Welcome</Link>
            <Link to='/client' activeClassName={css.active}>Client Profile</Link>
            <Link to='/diamond' activeClassName={css.active}>Education</Link>
            <Link to='/search' activeClassName={css.active}>Diamond Search</Link>
            <Link to='/jewellery' activeClassName={css.active}>Jewellery</Link>
            <Link to='/summary' activeClassName={css.active}>Summary</Link>
            <div className={css.settingsMenu}>
              <div className={css.currencyLink}>$ {this.props.currency}<CurrencyMenu /></div>
              <div className={[css.imgLink, css.menuLink].join(' ')}><Menu /></div>
              <div className={[css.imgLink, css.cartLink, this.props.cartVisible ? css.highlight : ''].join(' ')}
                onClick={this.props.toggleDisplayCart} />
            </div>
          </div>
        </nav>
      </div>
    )
  }
}

// react-router and redux don't play nicely together, hence the need to use { pure: false }
// When using connect, redux hijacks shouldComponentUpdate.  since the URL is not part of the
// redux state, it doesn't think the component should update on a route change, breaking
// activeClassName.
// TODO: use react-router-redux to keep the url in sync with the redux store and ditch {pure: false}
export default connect(mapStateToProps, mapDispatchToProps, null, {pure: false})(Navigation)



// WEBPACK FOOTER //
// ./src/components/navigation/index.js